import { Form } from "antd";
import { HeaderOverview } from "components";
import {
  ErrorDashboard,
  LoadingDashboard,
  Wrapper,
  checkDataObject,
} from "pages/overview";
import { useOverview } from "providers/overview";
import { useTranslation } from "react-i18next";
import { useGetDashboardAppSmoothUp } from "service/dashboard/central/overview";
import { SpaceStyle } from "..";

const SmoothUpApp = () => {
  const { t } = useTranslation();
  const { findDate, property } = useOverview();
  const smoothUpAppDate = Form.useWatch("smoothUpAppDate");
  const date = findDate(smoothUpAppDate, "month");

  const { data, isFetching, isError, error } = useGetDashboardAppSmoothUp({
    property,
    ...date,
  });

  const countSmoothUp = data ? checkDataObject(data) : "0";

  return (
    <Wrapper className="h-[300px]">
      <LoadingDashboard loading={isFetching}>
        <HeaderOverview
          title={t("number-of-user-using-app-work-up")}
          name="smoothUpAppDate"
        />
        {isError ? (
          <ErrorDashboard error={error} height="200px" />
        ) : (
          <SpaceStyle className="center " direction="vertical">
            <div className="count" style={{fontSize:"36px"}}>{`${countSmoothUp || "0"}`}</div>
            <div className="people"style={{fontSize:"24px"}}>{t("people")}</div>
          </SpaceStyle>
        )}
      </LoadingDashboard>
    </Wrapper>
  );
};

export default SmoothUpApp;
